export default "__VITE_ASSET__Gow4KCAB__"